import { useSelector, useDispatch } from 'react-redux';
import { CartoLayer, colorBins } from '@deck.gl/carto';
import { selectSourceById, updateLayer } from '@carto/react-redux';
import { useCartoLayerProps } from '@carto/react-api';
import htmlForFeature from 'utils/htmlForFeature';

export const HOUSEHOLDSINNOAAFLOODHIGH2070DIFFINVANY_LAYER_ID =
  'householdsInNoaaFloodHigh2070DiffInvAnyLayer';

const layerConfig = {
  title: 'Households In Noaa Flood High 2070 Diff',
};

function HouseholdsInNoaaFloodHigh2070DiffInvAnyLayer() {
  const dispatch = useDispatch();
  const { householdsInNoaaFloodHigh2070DiffInvAnyLayer } = useSelector(
    (state) => state.carto.layers
  );
  const source = useSelector((state) =>
    selectSourceById(state, householdsInNoaaFloodHigh2070DiffInvAnyLayer?.source)
  );
  const cartoLayerProps = useCartoLayerProps({ source });

  if (householdsInNoaaFloodHigh2070DiffInvAnyLayer && source) {
    return new CartoLayer({
      ...cartoLayerProps,
      id: HOUSEHOLDSINNOAAFLOODHIGH2070DIFFINVANY_LAYER_ID,

      stroked: false,
      pointRadiusUnits: 'pixels',
      lineWidthUnits: 'pixels',
      pickable: true,
      visible: householdsInNoaaFloodHigh2070DiffInvAnyLayer.visible,
      opacity: householdsInNoaaFloodHigh2070DiffInvAnyLayer.opacity,
      getFillColor: colorBins({
        attr: 'households_in_noaa_flood_high_2070_diff',
        domain: [-57, -1, 0, 0.01, 1, 5, 43],
        colors: [
          [178, 34, 34],
          [255, 0, 0],
          [255, 102, 102],
          [180, 210, 255],
          [153, 204, 255],
          [51, 153, 255],
          [51, 102, 255],
          [0, 0, 128],
        ],
      }),
      pointRadiusMinPixels: 5,

      onDataLoad: (data) => {
        dispatch(
          updateLayer({
            id: HOUSEHOLDSINNOAAFLOODHIGH2070DIFFINVANY_LAYER_ID,
            layerAttributes: { ...layerConfig },
          })
        );
        cartoLayerProps.onDataLoad && cartoLayerProps.onDataLoad(data);
      },

      onHover: (info) => {
        if (info?.object) {
          info.object = {
            html: htmlForFeature({
              feature: info.object,
              includeColumns: ['households_in_noaa_flood_high_2070_diff', 'geo_level_id'],
            }),
          };
        }
      },
    });
  }
}

export default HouseholdsInNoaaFloodHigh2070DiffInvAnyLayer;
